import Vue from 'vue'
import Router from 'vue-router'

import HelpList from '@/pages/HelpList'
import Help1 from '@/pages/Help1'
import Help2 from '@/pages/Help2'
import Help3 from '@/pages/Help3'
import Help4 from '@/pages/Help4'
import Help5 from '@/pages/Help5'
import Help6 from '@/pages/Help6'
import Help7 from '@/pages/Help7'
import Help8 from '@/pages/Help8'
import Help9 from '@/pages/Help9'
import Help10 from '@/pages/Help10'
import Help11 from '@/pages/Help11'
import Help12 from '@/pages/Help12'
import Help13 from '@/pages/Help13'
import Help14 from '@/pages/Help14'
import Help15 from '@/pages/Help15'
import Help16 from '@/pages/Help16'
import Help17 from '@/pages/Help17'
import Help18 from '@/pages/Help18'
import Help19 from '@/pages/Help19'
import Help20 from '@/pages/Help20'
import Help21 from '@/pages/Help21'
import Help22 from '@/pages/Help22'
import Help23 from '@/pages/Help23'
import Help24 from '@/pages/Help24'
import Help25 from '@/pages/Help25'
import Help26 from '@/pages/Help26'
import Help27 from '@/pages/Help27'
import Help28 from '@/pages/Help28'
import Help29 from '@/pages/Help29'
import Help30 from '@/pages/Help30'
import Help31 from '@/pages/Help31'
import Help32 from '@/pages/Help32'
import Help33 from '@/pages/Help33'
import Help34 from '@/pages/Help34'
import Help35 from '@/pages/Help35'
import Help36 from '@/pages/Help36'
import Help37 from '@/pages/Help37'
import Help38 from '@/pages/Help38'
import Help39 from '@/pages/Help39'
import Help40 from '@/pages/Help40'
import Help41 from '@/pages/Help41'
import HelpAdmin1 from '@/pages/HelpAdmin1'
import HelpAdmin2 from '@/pages/HelpAdmin2'
import HelpAdmin3 from '@/pages/HelpAdmin3'
import HelpAdmin99 from '@/pages/HelpAdmin99'

import FeaturesList from '@/pages/FeaturesList'
import FeaturesJoinClub from '@/pages/FeaturesJoinClub'
import FeaturesChat from '@/pages/FeaturesChat'
import FeaturesActivity from '@/pages/FeaturesActivity'
import FeaturesRank from '@/pages/FeaturesRank'
import FeaturesGPS from '@/pages/FeaturesGPS'
import FeaturesBean from '@/pages/FeaturesBean'
import FeaturesDailyMission from '@/pages/FeaturesDailyMission'
import FeaturesCheckDataSync from '@/pages/FeaturesCheckDataSync'
import FeaturesImproveDataPrecision from '@/pages/FeaturesImproveDataPrecision'
import FeaturesSwitchDataSource from '@/pages/FeaturesSwitchDataSource'
import FeaturesBindingAccount from '@/pages/FeaturesBindingAccount'
import FeaturesContactAdmin from '@/pages/FeaturesContactAdmin'
import FeaturesAdminCreateClub from '@/pages/FeaturesAdminCreateClub'
import FeaturesAdminMemberJoin from '@/pages/FeaturesAdminMemberJoin'
import FeaturesAdminChangeJoinPassword from '@/pages/FeaturesAdminChangeJoinPassword'
import FeaturesAdminUpdateClubInfo from '@/pages/FeaturesAdminUpdateClubInfo'
import FeaturesAdminUpdateTeam from '@/pages/FeaturesAdminUpdateTeam'
import FeaturesAdminUpdateMember from '@/pages/FeaturesAdminUpdateMember'
import FeaturesAdminSetAdmin from '@/pages/FeaturesAdminSetAdmin'
import FeaturesAdminCreateActivity from '@/pages/FeaturesAdminCreateActivity'
import FeaturesAdminCopyActivity from '@/pages/FeaturesAdminCopyActivity'
import FeaturesAdminDeleteActivity from '@/pages/FeaturesAdminDeleteActivity'
import FeaturesAdminExportActivityResult from '@/pages/FeaturesAdminExportActivityResult'
import FeaturesAdminExportData from '@/pages/FeaturesAdminExportData'
import FeaturesAdminCreateVirtualPathActivity from '@/pages/FeaturesAdminCreateVirtualPathActivity'
import FeaturesAdminCreateKeepActivity from '@/pages/FeaturesAdminCreateKeepActivity'
import FeaturesAdminCreateCommonActivity from '@/pages/FeaturesAdminCreateCommonActivity'
import FeaturesAdminCreateGPSRunActivity from '@/pages/FeaturesAdminCreateGPSRunActivity'
import FeaturesAdminCreateGPSActivity from '@/pages/FeaturesAdminCreateGPSActivity'

import V14NewFeatures from '@/pages/v14NewFeatures'
import V15NewFeatures from '@/pages/v15NewFeatures'
import V16NewFeatures from '@/pages/v16NewFeatures'
import V17NewFeatures from '@/pages/v17NewFeatures'

import ActivityTemplate from '@/pages/ActivityTemplate'

import VipGuide from '@/pages/VipGuide'
import PricingTable from '@/pages/PricingTable'

/* Added By Le Minh 2021/12/23 Start */
import HelpCategory11 from '@/pages/HelpCategory11'
import HelpCategory12 from '@/pages/HelpCategory12'
import HelpCategory13 from '@/pages/HelpCategory13'
import HelpCategory21 from '@/pages/HelpCategory21'
import HelpCategory22 from '@/pages/HelpCategory22'
import HelpCategory31 from '@/pages/HelpCategory31'
import HelpCategory32 from '@/pages/HelpCategory32'
import HelpCategory33 from '@/pages/HelpCategory33'
import HelpCategory34 from '@/pages/HelpCategory34'
import HelpCategory35 from '@/pages/HelpCategory35'
import HelpCategory36 from '@/pages/HelpCategory36'
import HelpCategory41 from '@/pages/HelpCategory41'
import HelpCategory42 from '@/pages/HelpCategory42'
import HelpCategory51 from '@/pages/HelpCategory51'
import HelpCategory52 from '@/pages/HelpCategory52'
import HelpCategory53 from '@/pages/HelpCategory53'
import HelpCategory61 from '@/pages/HelpCategory61'
import HelpCategory62 from '@/pages/HelpCategory62'
import HelpCategory71 from '@/pages/HelpCategory71'
/* Added By Le Minh 2021/12/23 End */

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/v14_new_features',
      name: 'V14NewFeatures',
      component: V14NewFeatures
    },
    {
      path: '/v15_new_features',
      name: 'V15NewFeatures',
      component: V15NewFeatures
    },
    {
      path: '/v16_new_features',
      name: 'V16NewFeatures',
      component: V16NewFeatures
    },
    {
      path: '/v17_new_features',
      name: 'V17NewFeatures',
      component: V17NewFeatures
    },
    {
      path: '/help',
      name: 'HelpList',
      component: HelpList
    },
    {
      path: '/help/1',
      name: 'Help1',
      component: Help1
    },
    {
      path: '/help/2',
      name: 'Help2',
      component: Help2
    },
    {
      path: '/help/3',
      name: 'Help3',
      component: Help3
    },
    {
      path: '/help/4',
      name: 'Help4',
      component: Help4
    },
    {
      path: '/help/5',
      name: 'Help5',
      component: Help5
    },
    {
      path: '/help/6',
      name: 'Help6',
      component: Help6
    },
    {
      path: '/help/7',
      name: 'Help7',
      component: Help7
    },
    {
      path: '/help/8',
      name: 'Help8',
      component: Help8
    },
    {
      path: '/help/9',
      name: 'Help9',
      component: Help9
    },
    {
      path: '/help/10',
      name: 'Help10',
      component: Help10
    },
    {
      path: '/help/11',
      name: 'Help11',
      component: Help11
    },
    {
      path: '/help/12',
      name: 'Help12',
      component: Help12
    },
    {
      path: '/help/13',
      name: 'Help13',
      component: Help13
    },
    {
      path: '/help/14',
      name: 'Help14',
      component: Help14
    },
    {
      path: '/help/15',
      name: 'Help15',
      component: Help15
    },
    {
      path: '/help/16',
      name: 'Help16',
      component: Help16
    },
    {
      path: '/help/17',
      name: 'Help17',
      component: Help17
    },
    {
      path: '/help/18',
      name: 'Help18',
      component: Help18
    },
    {
      path: '/help/19',
      name: 'Help19',
      component: Help19
    },
    {
      path: '/help/20',
      name: 'Help20',
      component: Help20
    },
    {
      path: '/help/21',
      name: 'Help21',
      component: Help21
    },
    {
      path: '/help/22',
      name: 'Help22',
      component: Help22
    },
    {
      path: '/help/23',
      name: 'Help23',
      component: Help23
    },
    {
      path: '/help/24',
      name: 'Help24',
      component: Help24
    },
    {
      path: '/help/25',
      name: 'Help25',
      component: Help25
    },
    {
      path: '/help/26',
      name: 'Help26',
      component: Help26
    },
    {
      path: '/help/27',
      name: 'Help27',
      component: Help27
    },
    {
      path: '/help/28',
      name: 'Help28',
      component: Help28
    },
    {
      path: '/help/29',
      name: 'Help29',
      component: Help29
    },
    {
      path: '/help/30',
      name: 'Help30',
      component: Help30
    },
    {
      path: '/help/31',
      name: 'Help31',
      component: Help31
    },
    {
      path: '/help/32',
      name: 'Help32',
      component: Help32
    },
    {
      path: '/help/33',
      name: 'Help33',
      component: Help33
    },
    {
      path: '/help/34',
      name: 'Help34',
      component: Help34
    },
    {
      path: '/help/35',
      name: 'Help35',
      component: Help35
    },
    {
      path: '/help/36',
      name: 'Help36',
      component: Help36
    },
    {
      path: '/help/37',
      name: 'Help37',
      component: Help37
    },
    {
      path: '/help/38',
      name: 'Help38',
      component: Help38
    },
    {
      path: '/help/39',
      name: 'Help39',
      component: Help39
    },
    {
      path: '/help/40',
      name: 'Help40',
      component: Help40
    },
    {
      path: '/help/41',
      name: 'Help41',
      component: Help41
    },
    {
      path: '/help/admin/1',
      name: 'HelpAdmin1',
      component: HelpAdmin1
    },
    {
      path: '/help/admin/2',
      name: 'HelpAdmin2',
      component: HelpAdmin2
    },
    {
      path: '/help/admin/3',
      name: 'HelpAdmin3',
      component: HelpAdmin3
    },
    {
      path: '/help/admin/99',
      name: 'HelpAdmin99',
      component: HelpAdmin99
    },

    // features
    {
      path: '/features',
      name: 'FeaturesList',
      component: FeaturesList
    },
    {
      path: '/features/join_club',
      name: 'FeaturesJoinClub',
      component: FeaturesJoinClub
    },
    {
      path: '/features/contact_admin',
      name: 'FeaturesContactAdmin',
      component: FeaturesContactAdmin
    },
    {
      path: '/features/binding_account',
      name: 'FeaturesBindingAccount',
      component: FeaturesBindingAccount
    },
    {
      path: '/features/switch_data_source',
      name: 'FeaturesSwitchDataSource',
      component: FeaturesSwitchDataSource
    },
    {
      path: '/features/improve_data_precision',
      name: 'FeaturesImproveDataPrecision',
      component: FeaturesImproveDataPrecision
    },
    {
      path: '/features/check_data_sync',
      name: 'FeaturesCheckDataSync',
      component: FeaturesCheckDataSync
    },
    {
      path: '/features/daily_mission',
      name: 'FeaturesDailyMission',
      component: FeaturesDailyMission
    },
    {
      path: '/features/bean',
      name: 'FeaturesBean',
      component: FeaturesBean
    },
    {
      path: '/features/gps',
      name: 'FeaturesGPS',
      component: FeaturesGPS
    },
    {
      path: '/features/rank',
      name: 'FeaturesRank',
      component: FeaturesRank
    },
    {
      path: '/features/activity',
      name: 'FeaturesActivity',
      component: FeaturesActivity
    },
    {
      path: '/features/chat',
      name: 'FeaturesChat',
      component: FeaturesChat
    },
    {
      path: '/features/admin_create_club',
      name: 'FeaturesAdminCreateClub',
      component: FeaturesAdminCreateClub
    },
    {
      path: '/features/admin_create_club',
      name: 'FeaturesAdminMemberJoin',
      component: FeaturesAdminMemberJoin
    },
    {
      path: '/features/admin_change_join_password',
      name: 'FeaturesAdminChangeJoinPassword',
      component: FeaturesAdminChangeJoinPassword
    },
    {
      path: '/features/admin_update_club_info',
      name: 'FeaturesAdminUpdateClubInfo',
      component: FeaturesAdminUpdateClubInfo
    },
    {
      path: '/features/admin_update_team',
      name: 'FeaturesAdminUpdateTeam',
      component: FeaturesAdminUpdateTeam
    },
    {
      path: '/features/admin_update_member',
      name: 'FeaturesAdminUpdateMember',
      component: FeaturesAdminUpdateMember
    },
    {
      path: '/features/admin_set_admin',
      name: 'FeaturesAdminSetAdmin',
      component: FeaturesAdminSetAdmin
    },
    {
      path: '/features/admin_create_activity',
      name: 'FeaturesAdminCreateActivity',
      component: FeaturesAdminCreateActivity
    },
    {
      path: '/features/admin_copy_activity',
      name: 'FeaturesAdminCopyActivity',
      component: FeaturesAdminCopyActivity
    },
    {
      path: '/features/admin_delete_activity',
      name: 'FeaturesAdminDeleteActivity',
      component: FeaturesAdminDeleteActivity
    },
    {
      path: '/features/admin_export_activity_result',
      name: 'FeaturesAdminExportActivityResult',
      component: FeaturesAdminExportActivityResult
    },
    {
      path: '/features/admin_export_data',
      name: 'FeaturesAdminExportData',
      component: FeaturesAdminExportData
    },
    {
      path: '/features/admin_create_virtual_path_activity',
      name: 'FeaturesAdminCreateVirtualPathActivity',
      component: FeaturesAdminCreateVirtualPathActivity
    },
    {
      path: '/features/admin_create_keep_activity',
      name: 'FeaturesAdminCreateKeepActivity',
      component: FeaturesAdminCreateKeepActivity
    },
    {
      path: '/features/admin_create_common_activity',
      name: 'FeaturesAdminCreateCommonActivity',
      component: FeaturesAdminCreateCommonActivity
    },
    {
      path: '/features/admin_create_gps_run_activity',
      name: 'FeaturesAdminCreateGPSRunActivity',
      component: FeaturesAdminCreateGPSRunActivity
    },
    {
      path: '/features/admin_create_gps_activity',
      name: 'FeaturesAdminCreateGPSActivity',
      component: FeaturesAdminCreateGPSActivity
    },

    {
      path: '/activity_template',
      name: 'ActivityTemplate',
      component: ActivityTemplate
    },

    {
      path: '/vip_guide',
      name: 'VipGuide',
      component: VipGuide
    },

    {
      path: '/pricing_table',
      name: 'PricingTable',
      component: PricingTable
    },

    /* Added By Le Minh 2021/12/24 Start */
    // Category

    {
      path: '/help_category/1_1',
      name: 'HelpCategory11',
      component: HelpCategory11
    },

    {
      path: '/help_category/1_2',
      name: 'HelpCategory12',
      component: HelpCategory12
    },

    {
      path: '/help_category/1_3',
      name: 'HelpCategory13',
      component: HelpCategory13
    },

    {
      path: '/help_category/2_1',
      name: 'HelpCategory21',
      component: HelpCategory21
    },

    {
      path: '/help_category/2_2',
      name: 'HelpCategory22',
      component: HelpCategory22
    },

    {
      path: '/help_category/3_1',
      name: 'HelpCategory31',
      component: HelpCategory31
    },

    {
      path: '/help_category/3_2',
      name: 'HelpCategory32',
      component: HelpCategory32
    },

    {
      path: '/help_category/3_3',
      name: 'HelpCategory33',
      component: HelpCategory33
    },

    {
      path: '/help_category/3_4',
      name: 'HelpCategory34',
      component: HelpCategory34
    },

    {
      path: '/help_category/3_5',
      name: 'HelpCategory35',
      component: HelpCategory35
    },

    {
      path: '/help_category/3_6',
      name: 'HelpCategory36',
      component: HelpCategory36
    },

    {
      path: '/help_category/4_1',
      name: 'HelpCategory41',
      component: HelpCategory41
    },

    {
      path: '/help_category/4_2',
      name: 'HelpCategory42',
      component: HelpCategory42
    },

    {
      path: '/help_category/5_1',
      name: 'HelpCategory51',
      component: HelpCategory51
    },

    {
      path: '/help_category/5_2',
      name: 'HelpCategory52',
      component: HelpCategory52
    },

    {
      path: '/help_category/5_3',
      name: 'HelpCategory53',
      component: HelpCategory53
    },

    {
      path: '/help_category/6_1',
      name: 'HelpCategory61',
      component: HelpCategory61
    },

    {
      path: '/help_category/6_2',
      name: 'HelpCategory62',
      component: HelpCategory62
    },

    {
      path: '/help_category/7_1',
      name: 'HelpCategory71',
      component: HelpCategory71
    }
    /* Added By Le Minh 2021/12/24 End */
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js